import auth0 from 'auth0-js';
import * as jwt_decode from "jwt-decode";
import { getCurrentUser } from '../actions';

export default class Auth {

  auth0;

  storageKeys = {
      accessToken: 'access_token',
      expiresAt: 'expires_at',
      permissions: 'https://kiatlee2.com.sg/permissions',
      userName: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name',
      redirectUri: 'redirectUri',
      remoteIPAddress: 'remoteIPAddress'
  };

  name = '';
  permissions = [];

  login() {
    this.auth0.authorize();
  }

  getAccessToken() {
    return localStorage.getItem(this.storageKeys.accessToken);
  }

  constructor({ clientId = '', redirectUri = '' }) {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);

    this.auth0 = new auth0.WebAuth({
      domain: 'kiatlee.auth0.com',
      clientID: clientId,
      redirectUri: redirectUri,
      audience: 'https://api.kiatlee2.com.sg',
      responseType: 'token',
      scope: 'openid'
    });

    var token = localStorage.getItem(this.storageKeys.accessToken);
    if (token) {
      var decodedToken = jwt_decode(token);
      this.name = decodedToken[this.storageKeys.userName];
      this.permissions = decodedToken[this.storageKeys.permissions];
    }
  }

  handleAuthentication() {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken) { //&& !authResult.idToken
        console.log('handleAuthentication', authResult);
        this.setSession(authResult);
        this.getRemoteIPAddress();
      } else {
        this.login();
        console.log('handleAuthentication', err);
      }
    });
  }

  getRemoteIPAddress() {
    getCurrentUser(this.getAccessToken(), (response) => {
      console.log('getRemoteIPAddress', response);
      let remoteIPAddress = response.headers['x-ip-remote-address'];
      localStorage.setItem(this.storageKeys.remoteIPAddress, remoteIPAddress);
      this.postLoginRedirect();
    }, (err) => {
      console.log('getRemoteIPAddress', err);
      this.postLoginRedirect();
    });
  }

  postLoginRedirect() {
    let redirectUri = localStorage.getItem(this.storageKeys.redirectUri);
    if (!redirectUri) redirectUri = '/';
    localStorage.removeItem(this.storageKeys.redirectUri);
    window.location.href = redirectUri;
  }

  setSession(authResult) {
    // Set the time that the Access Token will expire at
    let expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
    localStorage.setItem(this.storageKeys.accessToken, authResult.accessToken);
    localStorage.setItem(this.storageKeys.expiresAt, expiresAt);
  }

  logout() {
    // Clear Access Token and ID Token from local storage
    localStorage.removeItem(this.storageKeys.accessToken);
    localStorage.removeItem(this.storageKeys.expiresAt);
    localStorage.removeItem(this.storageKeys.redirectUri);
    localStorage.removeItem(this.storageKeys.remoteIPAddress);
    // navigate to the login page
    this.login();
  }

  isAuthenticated() {
    // Check whether the current time is past the
    // Access Token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem(this.storageKeys.expiresAt));
    return new Date().getTime() < expiresAt;
  }

  validateIntranet(mod, system = "ERP") {
    let remoteIPAddress = localStorage.getItem(this.storageKeys.remoteIPAddress);
    if (!remoteIPAddress) return true;
    for (let p of this.permissions) {
      if (!p.access) continue;
      for(let m of p.access) {
        if (!m.actions) continue;
        if (m.module.toLowerCase() === mod.toLowerCase() && m.actions.indexOf('Intranet') > -1) return remoteIPAddress === process.env.REACT_APP_INTRANET_IP_ADDRESS;
      }
    }
    return true;
  }

  hasAccess(mod, action, system = 'ERP') {
    if (!mod) return false;
    if (!action) return false;
    if (!this.permissions) return false;
    for (let p of this.permissions) {
      if (!p.access) continue;
      for(let m of p.access) {
        if (!m.actions) continue;
        for(let a of m.actions) {
          if (p.system.toLowerCase() === system.toLowerCase() && m.module.toLowerCase() && m.module.toLowerCase() === mod.toLowerCase() && a && a.toLowerCase() === action.toLowerCase()) return true;
        }
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/auth/auth.js